/**
	Everything in this files relates to the way the cart will work to allow for weather checks to add ice packs for 
	heat sensative products
*/
console.log('cart_icepack_check.js');
const ICEPACK_LOGGING = true;
function log(){
	if (ICEPACK_LOGGING){
		console.log(...arguments);
	}
}
window.addEventListener('DOMContentLoaded', function(){

	/**
	 * This is the json object that will be sent to the server for processing
	 * most is gathered on checkout button click, zip code get collected from user input
	*/
	let payloadToServer = {
		items: null,              // Array  - cart line items for reference
		sensitiveProducts: null,  // Array  - sensative items in cart
		icePacksAdded: null,      // Int    - number of ice packs already in cart
		zip: null                 // String - user input zip code
	};

	let responseState = null; // no response yet

	/***************************************************************************
	 *                 Helper Functions
	****************************************************************************/

	function goToCheckout(){
		window.location.href = "/checkout";
	}

	/**
	 *  Initinal opening of the modal, should present the zip code input.
	 */
	function showModal(){
		document.querySelector('#zip-check-results').innerHTML = "";
		document.querySelector('#destination-zip-code').value = "";

		navigateToModalStep(0);
		MicroModal.show('zip-modal');
	}

	/**
	 *  Initinal opening of the modal, should present the zip code input.
	 */
	function displayMessage(needs_packs, hours) {
		var message = 'No Ice Packs are required.';
		if (needs_packs){
			if (hours == 16) {
				message = "Icepacks ARE required. Please ship with FedEx First Overnight or UPS Next Day Air Early.";
			} else if (hours == 24) {
				message = "Icepacks ARE required. Must arrive within 24 hours, please ship with UPS Next Day Air or FedEx Priority Overnight.";
			} else if (hours == 36) {
				message = "Icepacks ARE required. Must arrive within 36 hours, please use UPS Next Day Air or FedEx Priority Overnight or FedEx 2nd Day AM (by noon).";
			} else if (hours == 42) {
				message = "";
			} else if (hours == 48) {
				message = "Icepacks ARE required. Must arrive within 2 days from shipping, please use FedEx 2Day or UPS 2nd Day Air.";
			} else if (hours == 72) {
				message = "Icepacks ARE required. Must arrive within 3 days from shipping, please use UPS 3 Day Select or FedEx Express Saver.";
			}
		}
		document.querySelector('#zip-check-results').innerHTML = '<p class="zip-check-output">' + message + '</p>';
	}

	if (document.querySelector('.local-skip')){
		document.querySelector('.local-skip').addEventListener('click', function(e){
			goToCheckout();
		});
	}

	function showElement(element){
		if (element){
			element.style.display = "block";
		}
	}

	function hideElement(element){
		if (element){
			element.style.display = "none";
		}
	}


	/**
	 *  Helps navigate to each of the different states that the modal can be in
	 */
	function navigateToModalStep(step) {
		let zipStep1       = document.querySelector('.weather-request-buttons');
		let zipStep2       = document.querySelector('.final-confirm-buttons');
		let zipStep3       = document.querySelector('.no-packs-confirm-buttons');
		let zipError       = document.querySelector('.zip-error');
		let zipCheckOutput = document.querySelector('.zip-check-output');
		let skipBtn        = document.querySelectorAll('.skip-to-checkout-button');
		let localSkip      = document.querySelector('.local-skip');
		let zipInput       = document.querySelector('#destination-zip-code');
		[zipStep1, zipStep2, zipStep3, zipError, skipBtn, zipInput, localSkip].forEach(function(element){
			if (element){
				if (element.length){
					Array.prototype.forEach.call(element, function(el){
						el.style.display = "none";
					})
				} else {
					element.style.display = "none";
				}
			}
		});
		switch(step) {
			case 0:
				/**
				 * Displays the zip input with no message or button
				 */
				showElement(localSkip);
				showElement(zipInput);
				break;
			case 1:
				/**
				 * Here we've validated the zip so we show the button
				 */
				showElement(zipInput);
				showElement(zipStep1);
				hideElement(localSkip);
				break;
			case 2:
				/**
				 * We need ice packs
				 */
				showElement(zipStep2);
				break;
			case 3:
				/**
				 * We DO NOT need ice packs
				 */
				showElement(zipStep3);
				break;
			case 'error':
				if (zipCheckOutput){
					zipCheckOutput.remove();
				}
				showElement(zipError);
				showElement(skipBtn);
				break;
		}
	}

	/**
	 *  Puts the Check Zip Code button into a loading state
	 */
	function zipButtonPleaseWait() {
		checkZipButton = document.querySelector("#zip-code-check-button")
		checkZipButton.innerHTML = 'Please Wait';
		window.pleaseWaitMessage = setInterval(function () {
			checkZipButton.innerText = checkZipButton.innerText + '.';
			if (checkZipButton.innerText == 'Please Wait....') {
				checkZipButton.innerText = 'Please Wait';
			}
		}, 500);
	}

	/**
	 *  Releases the Check Zip Code button from a loading state
	 */
	function resetZipButton() {
		clearInterval(window.pleaseWaitMessage) // Clears the "please wait..." message
		checkZipButton = document.querySelector("#zip-code-check-button")
		checkZipButton.innerHTML = 'Check Zip Code';
	}

	/**
	 *  Change handler for the acknowledgement check box
	 */
	document.querySelector('input[name="shipping-chances"]').addEventListener('change', function (e) {
		document.querySelector('#zip-code-confirm-button').style.display = "block";
		logAttributes({
			"Warn Inclement Weather": ((e.target.checked) ? "Yes" : "No"),
		})
	})

	/**
	 *  CONTINUE TO CHECKOUT button event handler
	 */
	document.querySelector('#zip-code-confirm-button').addEventListener('click', function(){
		if (responseState && responseState.packs_needed > 0){
			addAppropriateIcepacks(responseState.packs_needed, function(){
				// maybe log more attributes here
				goToCheckout();
			}); 
		} else {
			goToCheckout(); 
		}
	});

	/**
	 *  PROCEED TO CHECKOUT button event handler
	 */
	document.querySelector('#no-packs-confirm-button').addEventListener('click', function(){
		goToCheckout();
	});
	

	/**
	 *  Validates any zip code
	 */
	function validateAnyZip(elementValue) {
		this.zipUs = /^\d{5}$|^\d{5}-\d{4}$/
		this.zipCa = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/
		this.zipUk = /^[A-Z]{1,2}[0-9R][0-9A-Z]?\s*[0-9][A-Z-[CIKMOV]]{2}/
		this.zipRo = /^\d{6}$/
		this.zipSj = /^\d{4}\s{0,1}[A-Za-z]{2}$/
		this.zipNl = /^\d{4}$/
		this.zipBe = /^\d{4}$/
		this.zipIr = /^[ACDEFHKNPRTVWXY]{1}[0-9]{1}[0-9W]{1}[\ \-]?[0-9ACDEFHKNPRTVWXY]{4}$/

		return (this.zipUs.test(elementValue) ||
			this.zipCa.test(elementValue) ||
			this.zipUk.test(elementValue) ||
			this.zipRo.test(elementValue) ||
			this.zipSj.test(elementValue) ||
			this.zipNl.test(elementValue) ||
			this.zipBe.test(elementValue) ||
			this.zipIr.test(elementValue))
	}

	/**
	 * Updates the UI when the user is inputing a zipcode
	*/
	document.querySelector('#destination-zip-code').addEventListener('keyup', function (e) {
		if (validateAnyZip(this.value)) {
			navigateToModalStep(1)
		} else {
			navigateToModalStep(0);
		}
	})

	/***************************************************************************
	 *                 Main Functions
	****************************************************************************/

	/**
	 *  ZIP CODE SUBMIT button event handler
	 *   - checks the zip code's validity,
	 *   - sends the server payload,
	 *   - passes response to handler
	 */
	document.querySelector("#zip-code-check-button").addEventListener('click', function (e) {
		let zipInput = document.querySelector('#destination-zip-code');
		let zip = zipInput.value;
		if (validateAnyZip(zip)) {
			payloadToServer['zip'] = zip;
			console.log('payload json', payloadToServer);
			zipButtonPleaseWait();
			const processUrl  = "https://herculescandy.apps.fdgweb.com/process.php";
			fetch(processUrl, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(payloadToServer)
			}).then(function(data){
				return data.json();
			}).then(function(data){
				resetZipButton();
				console.log(data);
				if (data && data.success){
					console.log('handling this response', data);
					handleResponse(data);
				}
			});
		}
	});

	/*
		Log multiple attributes
	*/
	function logAttributes(atts, callback = function(){}){
		$.post('/cart/update.js', {
			attributes: atts
		}).done(function(data){
			data_parsed = JSON.parse(data);
			if (typeof data_parsed.attributes !== "undefined"){
				console.log('cart', data_parsed);
				console.log('cart attributes', data_parsed.attributes);
			} else {
				console.log('typeof attributes', typeof data_parsed.attributes);
				console.log('no attributes', data_parsed);
			}
			callback();
		});
	}

	/**
	*  Adds Appropriate Ice Packs
	*/
	function addAppropriateIcepacks(quantity, callback = function(){}) {

		// first check number of icepacks in cart
		fetch('/cart.js').then(function(data) {
			return data.json();
		}).then(function(cart){
			var icepacks_in_cart = 0;
			var icePackVariantIds  = ['5017786646560', '32472746426473'];
			cart.items.forEach(function(each){
				if (icePackVariantIds.indexOf(each.id.toString()) >= 0){
					icepacks_in_cart += each.quantity;
				}
			});

			// make adjustment to quantity
			var adjusted = (icepacks_in_cart > quantity) ? 0:quantity - icepacks_in_cart;

			// log the number of icepacks in cart before
			// and the adjustment made to what's needed
			logAttributes({
				"Icepacks in cart before add": icepacks_in_cart,
				"Adjusted Packs Needed": adjusted,
			},
				// supply callback to add the needed icepacks to the cart
				function(){

					// skip adding if none are needed
					if (adjusted > 0){
						$.ajax({
							method: "POST",
							url: "/cart/add.js",
							data: {
								items: [{
									quantity: adjusted,
									id: '5017786646560',
									properties: {'Added By': 'Weather Check'}
								}]
							},
                  success: function(response){
                      logAttributes({
                        "Added Icepacks Status": 'success'
                      }, function(){});
        		  },
                  error: function(xhr, ajaxOptions, thrownError){
                      logAttributes({
                        "Added Icepacks Status": 'error: ' . thrownError
                      }, function(){});
                  },
							dataType: 'json'
						}).done(function (cart) {
							fetch('/cart.js').then(function(data) {
								return data.json();
							}).then(function(cart){

								// log cart
								console.log('cart before going to checkout', cart);

								// looking again to see what's in the cart for logging
								var icepacks_in_cart = 0;
								var icePackVariantIds  = ['5017786646560', '32472746426473'];
								cart.items.forEach(function(each){
									if (icePackVariantIds.indexOf(each.id.toString()) >= 0){
										icepacks_in_cart += each.quantity;
									}
								});

								// log what's actually been added and pass the top level callback
								logAttributes({
									"Added Icepacks": icepacks_in_cart
								}, callback);
							});
						});
					}
				}
			);
		});
	}

	/**
	 *  START HERE, this is where we run code on form submit 
	 * 
	 *  i.e. the CHECKOUT BUTTON handler
	 * 
	 *  This determines if the zip modal should open to check for needed icepacks,
	 *  or if we should move on to checkout. Much of the server payload is compiled here.
	 */
	document.querySelector('form.cart').addEventListener('submit', function(e){
		e.preventDefault();

		// if international customer, skip to checkout
		if (Shopify.customerCountry && Shopify.customerCountry != "United States"){
			const processUrl  = "https://herculescandy.apps.fdgweb.com/log_country.php";
			fetch(processUrl, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ country: Shopify.customerCountry })
			}).then(function(){
				goToCheckout();
			});
			return;
		}

		fetch('/cart.js').then(function(data) {
			return data.json();
		}).then(function(cart){
			log(cart);
			let icePacksAdded     = 0;
			let icePackVariantIds  = ['5017786646560', '32472746426473'];
			var chocProdTypes     = "assorted chocolates, chocolate clusters and barks, chocolate covered, chocolate novelty, chunk chocolate, peanut butter filled, candy bar, chocolate covered".split(', ')
			var hardProdTypes     = "hard candy".split(', ')
			var ribbonProdTypes   = "ribbon candy".split(', ')
			var brittleProdTypes  = "nut brittle".split(', ')
			const allProdTypes    = chocProdTypes.concat(hardProdTypes, ribbonProdTypes, brittleProdTypes);
			let sensitiveProducts = {
				'Chocolate':  [],
				'Hard Candy': [],
				'Ribbon':     [],
				'Brittle':    []
			};
			let shouldShowModal = false;
			let items = cart.items;
			let payload_items = [];
			for (let i = 0; i < items.length; i++) {

				let itemType = items[i].product_type.toLowerCase();

				let itemEssentials = {
					product_id: items[i].product_id,
					variant_id: items[i].variant_id,
					quantity: items[i].quantity,
					product_type: items[i].product_type,
					final_line_price: items[i].final_line_price
				}

				if (icePackVariantIds.includes(String(items[i].variant_id))) {
					icePacksAdded += items[i].quantity;
				}

				if (allProdTypes.includes(itemType)){
					shouldShowModal = true;
					if (chocProdTypes.includes(itemType)){
						sensitiveProducts['Chocolate'].push(itemEssentials);
					}
					if (hardProdTypes.includes(itemType)){
						sensitiveProducts['Hard Candy'].push(itemEssentials);
					}
					if (ribbonProdTypes.includes(itemType)){
						sensitiveProducts['Ribbon'].push(itemEssentials);
					}
					if (brittleProdTypes.includes(itemType)){
						sensitiveProducts['Brittle'].push(itemEssentials);
					}
				}

				// add item essentials to items array
				payload_items.push(itemEssentials)
			}

			if (shouldShowModal){
				showModal();
				navigateToModalStep(0);
				payloadToServer = {
					userAgent: navigator.userAgent,
					items: payload_items,
					sensitiveProducts,
					icePacksAdded,
					zip: null
				};
				log('starting payload, still need zipcode', payloadToServer);
			} else {
				goToCheckout();
			}
		});
	});

	/**
	 * 	HANDLE SERVER RESPONSE
	 * 
	 * compile info to log to the cart and decide which modal configuration to display
	 */
	function handleResponse(response){
		console.log('server response', response);
		responseState = response; // this way its global to be used by other event handlers

		var attributesToLog = {}

		// add zip to attributes
		attributesToLog['Zip'] = response['Zip'];

		// prepare Estimated Ground Transit Times for logging to cart
		var processStr = '';
		var transitTimes = response['Estimated Ground Transit Times'];
		if(typeof transitTimes.FedEx !== 'undefined') {
		   processStr += "FedEx: " + transitTimes.FedEx
		}
		if(typeof transitTimes.UPS !== 'undefined') {
		   processStr += " UPS: " + transitTimes.UPS
		}
		attributesToLog["Estimated Ground Transit Times"] = processStr;


		// prepare Estimated High Temps By Day for logging to cart
		var preparedForecast = ''
		var temps = response['Estimated High Temps By Day'];
		console.log("Temps", temps);
		for (const zip in temps){
			if(preparedForecast == '') {
				preparedForecast += zip + ': <br>'
			} else {
				preparedForecast += '<br>' + zip + ': <br>'
			}
			var zip_temp = temps[zip]; 
			for (const date in zip_temp){
				preparedForecast += '(' + date + ': ' + zip_temp[date] + '), ';
			}
		};
		console.log('preparedForecast', preparedForecast);
		attributesToLog["Estimated High Temps By Day"] = preparedForecast;

		attributesToLog["Max Hours"]           = response['max_hours'];
		attributesToLog["Need Packs"]          = response['need_pack'];
		attributesToLog["Number Packs Needed"] = response['packs_needed'];

		var key_map = {
			delivery_start: "Delivery Start",
			fedex_end: "FedEx End",
			fedex_backup_end: "FedEx Backup End",
			UPS_end: "UPS End",
			UPS_backup_end: "UPS Backup End"
		}
		let str = "";
		let first = true;
		for (const [key, value] of Object.entries(response['Significant Times'])) {
			var time = value.slice(0, 4) + '-' + value.slice(4, 6) + '-' + value.slice(6);
			var temp = response['Significant Temps'][key];
			var prop = key_map[key];
			if (!first){
				str += ', ';
			} else {
				first = false;
			}
			str += `${prop}: (${time}: ${temp})`;
		};
		attributesToLog["Significant Times"] = str;

		attributesToLog['Ruleset'] = response['Ruleset'];
      
        
        console.log(response['price_tally']);
      	let price_report = "Prices Totalled: ";
        let prices = [];
        for (const category in response['price_tally']){
          if (category != 'total'){
          	response['price_tally'][category].forEach(function(each){
          		prices.push((new Number(each.final_line_price / 100)).toFixed(2));
          	});
          }
      	}
        price_report += prices.join(', ') + " Total: " + (new Number(response['price_tally'].total / 100).toFixed(2));
      	console.log({ price_report} );
	
      	attributesToLog['Prices'] = price_report;
      
		console.log({ attributesToLog });

		// log to cart
		logAttributes(attributesToLog); 

      	
		if (response.need_pack){
			displayMessage(response.need_pack, response.max_hours);
			navigateToModalStep(2);
			// go to the CONTINUE TO CHECKOUT button event handler
		} else {
			displayMessage(false, response.max_hours);
			navigateToModalStep(3);
		}
	}
});
